import { useRootLoader } from "src/storage";

export const useAxiosGateLoader = (gateId: string) => {
  return useRootLoader(gateId);
};
